module.exports = __webpack_public_path__ + "static/media/title.a4f61396.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/title.png
// module id = 779
// module chunks = 0